<template>
  <BaseFormFieldLayout
    :id="id"
    :label="label"
    :note="note"
    :error-message="errorMessage"
    :field-class="fieldClass"
    :label-class="labelClass"
  >
    <input
      v-bind="$attrs"
      :id="id"
      v-model="model"
      class="form-check-input m-0 cursor-pointer"
      :class="[errorMessage.length ? 'is-invalid' : '']"
      type="checkbox"
    />
  </BaseFormFieldLayout>
</template>

<script lang="ts" setup>
const model = defineModel<boolean>()

withDefaults(
  defineProps<{
    id: string
    label?: string
    note?: string
    errorMessage?: string
    fieldClass?: string
    labelClass?: string
  }>(),
  {
    label: '',
    note: '',
    errorMessage: '',
    fieldClass: '',
    labelClass: '',
  },
)
</script>
